import '@material/mwc-icon-button/mwc-icon-button.js';
import { ActionDetail } from '@material/mwc-list/mwc-list-foundation.js';
import '@material/mwc-list/mwc-list-item.js';
import '@material/mwc-menu/mwc-menu.js';
import { useState, view, View } from '@esui/core';
import { css } from 'lit';
import { html } from 'lit';
import { IconButton } from '../icon-button/index.js';

export interface MenuItem {
  name: string;
  value: string;
}

export class DotMenuProps {
  menu: MenuItem[] = [];
  onSelected?: (item: MenuItem) => void = undefined;
  trigger?: View & { onClick?: (_: () => void) => View } = undefined;
}

function template({ menu, onSelected, trigger }: DotMenuProps) {
  const [open, setOpen] = useState(false);

  const resolvedTrigger = trigger ?? IconButton('more_vert');

  return html`
    <div class="menu">
      ${resolvedTrigger.onClick?.(() => setOpen(isOpen => !isOpen)).body}

      <mwc-menu
        ?open=${open}
        @closed=${() => setOpen(false)}
        @action=${(e: { detail: ActionDetail }) => {
          onSelected?.(menu[e.detail.index]);
        }}
      >
        ${menu.map(({ name }) => html`<mwc-list-item>${name}</mwc-list-item>`)}
      </mwc-menu>
    </div>
  `;
}

const cssTemplate = css`
  *,
  *::after,
  *::before {
    padding: 0;
    margin: 0;
  }
  .menu {
    position: relative;
  }
  mwc-list-item {
    padding: 0 1rem;
  }
`;

export const [DotMenu, DotMenuView] = view('jsview-mdc-dot-menu', {
  template,
  cssTemplate,
  Props: DotMenuProps,

  mapBuilder:
    DotMenuBuilder =>
    (...menu: MenuItem[] | string[]) => {
      if (menu.length > 0 && typeof menu[0] === 'string') {
        return DotMenuBuilder().menu(toMenu(menu as string[]));
      }
      return DotMenuBuilder().menu(menu as MenuItem[]);
    },
});

export function toMenu(itemArray: string[]): MenuItem[] {
  return itemArray.map(name => ({ name, value: name }));
}
